module.exports = __webpack_public_path__ + "img/5.83479f33.png";